import {Button, ButtonProps} from '@mantine/core';
import {AiOutlineReload} from 'react-icons/ai';

import {useReprovisionPipelineMutation} from '../hooks/usePipelinesQuery';
import {Pipeline} from '../types';


const REPROVISIONABLE_STATUSES = ['FAILED', 'ACTIVE'];

interface ReprovisionRecordButtonProps extends ButtonProps {
    pipeline: Pipeline;
}

export const ReprovisionRecordButton = ({pipeline, ...props}: ReprovisionRecordButtonProps) => {

    const reprovisionPipelineMutation = useReprovisionPipelineMutation();

    const disabled = !pipeline.pipelineStatus
        || !REPROVISIONABLE_STATUSES.includes(pipeline.pipelineStatus);

    const handleReprovision = async () => {
        const confirmed = window.confirm(
            `Reprovision pipeline "${pipeline.name ?? pipeline.id}"? This will re-deploy the underlying CloudFormation stack.`
        );
        if (!confirmed) return;

        await reprovisionPipelineMutation.mutateAsync(pipeline.id);
    };

    return (
        <Button
            disabled={disabled}
            onClick={handleReprovision}
            loading={reprovisionPipelineMutation.isPending}
            leftSection={<AiOutlineReload/>}
            {...props}
        >
            Reprovision
        </Button>
    );

};
